import { isOverdueOpenInvoice } from "./accountsReceivable";
import { countInvoicesByStatus } from "./invoiceHubDashboard";
import {
  INVOICE_ACTIVE_HUB_STATUSES,
  resolveInvoiceStatus,
} from "./invoices";

/** Hub filter token. Not an invoice lifecycle status. */
export const INVOICE_HUB_OVERDUE_FILTER = "overdue";

export const INVOICE_HUB_FILTER_CHIPS = Object.freeze([
  { value: "draft", label: "Draft" },
  { value: "sent", label: "Sent" },
  { value: INVOICE_HUB_OVERDUE_FILTER, label: "Overdue" },
  { value: "paid", label: "Paid" },
  { value: "archived", label: "Archived" },
]);

/**
 * Route/navigation filter for Invoice Hub.
 * `null` is All. `"overdue"` stays a derived filter and is never coerced to draft.
 */
export function resolveInvoiceHubFilter(value) {
  if (value == null || value === "" || value === "all") return null;
  if (value === INVOICE_HUB_OVERDUE_FILTER) return INVOICE_HUB_OVERDUE_FILTER;
  return resolveInvoiceStatus(value);
}

export function invoiceMatchesHubFilter(invoice, statusFilter, asOfDate = new Date()) {
  if (statusFilter === INVOICE_HUB_OVERDUE_FILTER) {
    return isOverdueOpenInvoice(invoice, asOfDate);
  }

  const status = resolveInvoiceStatus(invoice?.status);
  if (statusFilter == null) {
    return INVOICE_ACTIVE_HUB_STATUSES.includes(status);
  }
  return status === statusFilter;
}

export function buildInvoiceHubFilterOptions(invoices = [], asOfDate = new Date()) {
  const counts = countInvoicesByStatus(invoices);
  const overdue = invoices.filter((invoice) =>
    isOverdueOpenInvoice(invoice, asOfDate),
  ).length;

  return [
    {
      value: "all",
      label: "All",
      count: counts.draft + counts.sent + counts.paid,
    },
    { value: "draft", label: "Draft", count: counts.draft },
    { value: "sent", label: "Sent", count: counts.sent },
    { value: INVOICE_HUB_OVERDUE_FILTER, label: "Overdue", count: overdue },
    { value: "paid", label: "Paid", count: counts.paid },
    { value: "archived", label: "Archived", count: counts.archived },
  ];
}
